import React, { Fragment } from 'react'

import Banner from './Banner'
import Content from './Content'

export default function OurSystemPolicyPage() {
    return (
        <Fragment>
            <Banner />
            <Content />
        </Fragment>
    )
}
